<template>
	<div class="tabulation">
		<el-card class="chart-card">
			<!-- 搜索框 -->
			<div class="grabble">
				 <div style="width: 80%;display: flex;">
					<el-input class="hunt" v-model="designation" placeholder="请输入会员姓名" size="large" @input="orangutan" clearable/>
					<el-input class="hunt" v-model="serial" placeholder="请输入会员编码" size="large" @input="legs" clearable/>
					<!-- 功能类型  -->
					<el-select class="hunt" v-model="values" placeholder="请选择功能类型 " clearable @clear="empty"
						size="large">
						<el-option label="我为群众办实事" value="1" style="width:100%; text-align-last: center;"></el-option>
						<el-option label="健步走" value="2" style="width:100%; text-align-last: center;"></el-option>
						<el-option label="积分" value="3" style="width:100%; text-align-last: center;"></el-option>
						<el-option label="通知公告" value="4" style="width:100%; text-align-last: center;"></el-option>
						<el-option label="日常活动通知" value="5" style="width:100%; text-align-last: center;"></el-option>
						<el-option label="其他短信通知" value="6" style="width:100%; text-align-last: center;"></el-option>
					</el-select>
					<!-- 会员组织名称搜索 -->
					<el-select @focus="closeIt" class="hunt" v-model="ability" placeholder="请选择单位名称" size="large"
						@click="multiple" clearable @change="numerical" ref="selectIt" />
					<!-- 派发时间 -->
					<el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始时间"
						end-placeholder="结束时间" size="large" @change="immediUpdate" />
						<!-- 状态 -->
						<el-select style="margin-left: 10px;" v-model="values1" placeholder="请选择状态" clearable @clear="empty"
							size="large">
							<el-option label="成功" value="1" style="width:100%; text-align-last: center;"></el-option>
							<el-option label="失败" value="2" style="width:100%; text-align-last: center;"></el-option>
						</el-select>
					<!-- 搜索 -->
					<el-button style="margin-left: 10px" type="primary" size="large" @click="search1"
						:loading='formative'><el-icon class="cancelgu">
							<Search />
						</el-icon>搜索</el-button>
				</div>
			</div>
			<div class="summation">
				<div class="hint">统计 : {{zong}}条</div>
			</div>
			<div class="sms-template-action">
				<el-button type="primary" size="default" @click="append">短信模板</el-button>
			</div>
			<el-table ref="tableRef" v-loading="loading" class="sms-push-table" :data="filterTableData" style="width: 100%" :fit="true" row-key="unionId" @cell-mouse-enter="obtain" border
				:empty-text="texts" :header-cell-style="{ background: '#F5F7FA' }" @row-click="unit">
				<!-- 会员姓名  -->
				<el-table-column fixed label="会员姓名" prop="name" align="center" :show-overflow-tooltip='true'
					min-width="120">
				</el-table-column>
				<!-- 会员编码  -->
				<el-table-column label="会员编码 " prop="username" align="center" :show-overflow-tooltip='true' min-width="120">
				</el-table-column>
				<!-- 单位名称 -->
				<el-table-column label="单位名称 " prop="unitName" align="center" :show-overflow-tooltip='true' min-width="200">
				</el-table-column>
				<!-- 所在组织 -->
				<el-table-column label="所属工会" prop="unionName" align="center" :formatter="quantum"  min-width="250"
					:show-overflow-tooltip='true'>
				</el-table-column>
				<!-- 功能类型 -->
				<el-table-column label="功能类型 " prop="messageType" align="center" :show-overflow-tooltip='true' min-width="150" :formatter="formatSex3">
				</el-table-column>
				<!-- 接收手机号 -->
				<el-table-column label="接收手机号 " prop="providersMobile" align="center" :show-overflow-tooltip='true' min-width="200">
				</el-table-column>
				<!-- 发送时间 -->
				<el-table-column label="发送时间 " prop="createTime" align="center" :show-overflow-tooltip='true' min-width="180" :formatter="reach">
				</el-table-column>
				<!-- 状态 -->
				<el-table-column label="状态 " prop="state" align="center" :show-overflow-tooltip='true' min-width="120" :formatter="formatSex">
					<template #default="scope">
						 <div v-show="scope.row.state==1">成功</div>
						 <div v-show="scope.row.state==2" style="color: red;">失败</div>
					</template>
				</el-table-column>
				<!-- 短信模板编号 -->
				<el-table-column label="短信模板编号" prop="templateCode" align="center" :show-overflow-tooltip='true' min-width="180">
				</el-table-column>
				<!-- 操作类型  -->
				<el-table-column label="操作类型" prop="operationType" align="center" :show-overflow-tooltip='true' min-width="150" :formatter="formatSex1">
				</el-table-column>
				<!-- 操作方式 -->
				<el-table-column label="操作方式 " prop="operationMethod" align="center" :show-overflow-tooltip='true' min-width="120" :formatter="formatSex2">
				</el-table-column>
				<!-- 备注 -->
				<el-table-column label="备注" prop="reason" align="center" :show-overflow-tooltip='true' min-width="300">
				</el-table-column>

			</el-table>
			<!-- 表格分页 -->
			<el-pagination hide-on-single-page="true" layout="prev, pager, next,sizes" :page-sizes="[6, 12, 18, 24]"
				:current-page="currentPage" :page-size="pagesize" :total="paginationTotal" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" />
		</el-card>
		<!-- 所属组织弹窗 -->
		<div>
			<el-dialog v-model="visible" title="单位名称" width="500px" top="10vh" custom-class="organization-dialog"
				:close-on-click-modal="true" destroy-on-close>
				<el-tree :data="texture" :props="defaultProps" accordion highlight-current @node-click="dendrogram" />
				<template #footer><el-button type="primary" @click="confirmOrganization">确定</el-button></template>
			</el-dialog>
		</div>
		<!-- 删除按钮弹窗 -->
		<!-- <el-dialog v-model="remove" title="动态删除" width="30%" center>
			<div class="labor">
				<div class="sure">确定删除此动态吗？</div>
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button class="asd" size="large" type="primary" @click="affirm">确定</el-button>
					<el-button class="dsa" size="large" @click="remove=false">取消</el-button>
				</span>
			</template>
		</el-dialog> -->
	</div>
</template>
<script>
	import {
		WalletFilled,
		Van,
		ShoppingCartFull,
		Search,
		Download
	} from "@element-plus/icons-vue";
	import {
		useRouter,
		useRoute,
		onBeforeRouteLeave
	} from "vue-router";
	import {
		ref,
		nextTick,
		onMounted,
		onDeactivated,
		onBeforeUnmount,
		onActivated
	} from 'vue';
	import {
		ElMessage,
		ElMessageBox
	} from "element-plus";
	import {
		PFintegral,
		ZClist,
		FYintegral,
		FPtotal,
		smsPush,
	} from "../../../utils/api";
	import {
		useStore
	} from "vuex";
	import qs from 'qs';
	import moments from 'moment'
	// import moments from 'moment'
	export default {
		name: "smsPush",
		computed: {},
		setup() {
			const route = useRoute();
			// 保存列表页离开前的真实横向滚动位置，避免 keep-alive 恢复时表头和内容错位。
			const tableRef = ref(null)
			const refreshTableLayout = () => {
				nextTick(() => {
					tableRef.value?.doLayout?.()
				})
			}
			onMounted(() => {
				window.addEventListener('resize', refreshTableLayout)
			})
			onBeforeUnmount(() => {
				window.removeEventListener('resize', refreshTableLayout)
			})
			const tableScrollLeft = ref(0)
			const getTableScrollWrap = () =>
				tableRef.value?.scrollBarRef?.wrapRef ||
				tableRef.value?.$el?.querySelector?.('.el-scrollbar__wrap')
			const saveTableScrollPosition = () => {
				const scrollWrap = getTableScrollWrap()
				if (scrollWrap) tableScrollLeft.value = scrollWrap.scrollLeft
			}
			const restoreTableScrollPosition = () => {
				nextTick(() => {
					tableRef.value?.doLayout?.()
					window.requestAnimationFrame(() => {
						tableRef.value?.setScrollLeft?.(tableScrollLeft.value)
						window.requestAnimationFrame(() => {
							tableRef.value?.setScrollLeft?.(tableScrollLeft.value)
						})
					})
				})
			}
			onBeforeRouteLeave(saveTableScrollPosition)
			// 搜索按钮加载
			let formative = ref(false)
			// 成功弹窗
			let anew = ref(false)

			let quoth = ref('')
			// 判断状态
			let formatSex = (row, column, state) => {
				if (state == 1) {
					return "成功";
				} else if (state === 2) {
					return "失败";
				}
			};
			// 判断操作类型
			let formatSex1 = (row, column, operationType) => {
				if (operationType == 1) {
					return "程序发送";
				} else if (operationType === 2) {
					return "手动发送";
				}
			};
			// 判断操作方式
			let formatSex2 = (row, column, operationMethod) => {
				if (operationMethod == 1) {
					return "按工会发送";
				} else if (operationMethod === 2) {
					return "按手机号发送";
				}
			};
			// 判断功能类型
			let formatSex3 = (row, column, messageType) => {
				if (messageType == 1) {
					return "我为群众办实事";
				} else if (messageType === 2) {
					return "健步走";
				} else if (messageType === 3) {
					return "积分";
				} else if (messageType === 4) {
					return "通知公告";
				} else if (messageType === 5) {
					return "日常活动通知";
				} else if (messageType === 6) {
					return "其他短信通知";
				}
			};
			// 下拉隐藏
			let selectIt = ref()
			let closeIt = () => {
				selectIt.value.blur();
			}

			// 加载中
			const acting = ref(false)
			// 按钮禁用
			const jinyong = ref(false)
			// 工会清空
			const numerical = (e) => {
				if (e == '') {
					unitAbbreviation.value = ''
				}
			}

			const pleased = ref()




			// 数据总共条数
			let zong = ref(null)
			const paginationTotal = ref(0)
			// let reach = (row, colum, cellValue) => {
			// 	if (typeof cellValue == 'number') {
			// 		return moments(cellValue * 1000).format().substring(0, 10)
			// 	}
			// }
			let reach = (row, colum, cellValue) => {
				if (typeof cellValue == 'number') {
					return moments(cellValue * 1000).format("YYYY-MM-DD HH:mm")
				}
			}
			// 列表数据循环
			const filterTableData = ref([])
			const loading = ref(false)
			const prepareTableLoading = () => {
				loading.value = true
				zong.value = 0
				texts.value = '加载中'
			}
			// 表格数据接口
			let list = () => {
				prepareTableLoading()
				let data = {
					limit: branches.value,
					page: currentPage.value
				}
				smsPush(qs.stringify(data)).then((res) => {
					if (res.data.code == 0) {
						zong.value = res.data.data.messagePage.totalCount
						paginationTotal.value = res.data.data.messagePage.totalCount
						filterTableData.value = res.data.data.messagePage.list
						if (filterTableData.value.length == 0) {
							texts.value = '暂无数据'
						}
					}
				}).catch(() => {
					texts.value = '加载失败'
				}).finally(() => {
					loading.value = false
				})
			}
			// 分页获取积分的派发日志
			// 动态加载数据
			let branches = ref(12)
			// 分页
			let currentPage = ref(1)
			let pagesize = ref(12)
			let handleSizeChange = (size) => {
				pagesize.value = size
				branches.value = size
				currentPage.value = 1
				if (designation.value !== '' || serial.value !== '' || unitAbbreviation.value !== '' || a.value !== '' || b.value !== '' || values.value !== '' || values1.value !== '') {
					search()
				} else {
					list()
				}
			}
			let handleCurrentChange = (size) => {
				currentPage.value = size
				texts.value = '加载中'
				if (designation.value !== '' || serial.value !== '' || unitAbbreviation.value !== '' || a.value !== '' || b.value !== '' || values.value !== '' || values1.value !== '') {
					search()
				} else {
					list()
				}
			}


			// 加载中
			let texts = ref('加载中')
			let translate = ref(2)
			onActivated(() => {
				translate.value = route.params.userId
				// translate.value=route.params.userId
				if(translate.value == 1){
				  texts.value='加载中'
				  list()
				  // 所有组织列表接口
				  lang()
				}
				// if (translate.value == 1) {
				// 	a.value = ''
				// 	b.value = ''
				// 	unitAbbreviation.value = ''
				// 	serial.value = ''
				// 	name.value = ''
				// 	texts.value = '加载中'
				// 	branches.value = 12
				// 	currentPage.value = 1
				// 	list()
				// 	// 所有组织列表接口
				// 	lang()
				// }
				restoreTableScrollPosition()
			})

			let search1 = () => {
				formative.value = true
				search()
			}


			// 搜索框点击
			let search = () => {
				prepareTableLoading()

				// 搜索接口
				let data = {
					limit: branches.value,
					page: currentPage.value,
					state:values1.value,
					messageType:values.value,
					// 开始时间 结束时间
					startTime: a.value,
					endTime: b.value,
					// 工会标识
					unitAbbreviation: unitAbbreviation.value,
					username:serial.value,
					name:designation.value, 
				}
				smsPush(qs.stringify(data)).then((res) => {

					if (res.data.code == 0) {
						formative.value = false
						zong.value = res.data.data.messagePage.totalCount
						paginationTotal.value = res.data.data.messagePage.totalCount
						filterTableData.value = res.data.data.messagePage.list

						if (filterTableData.value.length == 0) {
							texts.value = '暂无数据'
						}
					} else if (res.data.code !== 0) {
						ElMessage({
							message: res.data.msg,
							type: "error",
							center: true,
						});
					}
				}).catch(() => {
					texts.value = '加载失败'
				}).finally(() => {
					formative.value = false
					loading.value = false
				})
			}

			let a = ref('')
			let b = ref('')

			// 时间清空监听
			const immediUpdate = (e) => {
				if (e !== null) {
					a.value = new Date(e[0]).getTime() / 1000
					b.value = new Date(e[1]).getTime() / 1000
				} else if (e == null) {
					a.value = ''
					b.value = ''
				}
			}

			// 搜索组织列表接口
			// 获取code 
			let Hcode = ref('')
			// 搜索组织选择值
			let ability = ref('')
			// 标识
			let unitAbbreviation = ref('')
			// 弹窗内暂存的组织项，确认后再回填搜索条件
			let selectedOrganization = ref(null)
			// 弹窗树形选择
			let dendrogram = (node) => {
				selectedOrganization.value = node
			}
			const confirmOrganization = () => {
				if (selectedOrganization.value) {
					ability.value = selectedOrganization.value.unitName
					unitAbbreviation.value = selectedOrganization.value.unitAbbreviation
				}
				visible.value = false
			}
			let treeData = ref([])
			const yes1 = () => {
				form.coding = options.value.unionName
				visible1.value = false;
			};


			onMounted(() => {
				// 获取当前页path
				lang()
				list()
			})
			const lang = () => {
				ZClist().then((res) => {
					texture.value = res.data.data.unitList
				})
			}
			// 弹窗组织列表树形
			let texture = ref([])
			const defaultProps = {
				label: 'unitName',
			}
			// 选择组织按钮
			let multiple = () => {
				selectedOrganization.value = null
				visible.value = true
			}
			// 搜索组织弹窗
			let visible = ref(false)
			// 会员编码框
			let serial = ref('')
			// 功能类型
			const values = ref('')
			//状态
			const values1 = ref('')
			// 搜索框变化值
			let orangutan = () => {
				// if(designation.value==''&&serial.value==''&&ability.value==''&&achieve.value==''&&asdf.value==''||asdf.value==null){
				//   list()
				//   console.log('空了')
				// }
				// console.log('变化了')
			}
			// 姓名输入框值
			let designation = ref('')

			// 时间选择
			let value1 = ref('')
			const whirl = ref(false)
			// 待办内容点击事件
			const router = useRouter()
			// 待办内容
			const tableData = [];
			// 头像加载失败
			const errorHandler = () => true;
			// 头部添加跳转
			let append=()=>{
			  router.push('/smsTemplate')
			}
			return {
				tableRef,
				formative,
				search1,
				quoth,
				anew,
				selectIt,
				closeIt,
				// error,
				jinyong,
				numerical,

				immediUpdate,
				loading,
				reach,
				filterTableData,
				// 分页
				zong,
				paginationTotal,
				branches,
				handleCurrentChange,
				handleSizeChange,
				currentPage,
				pagesize,
				// 组织弹窗
				ability,
				texture,
				visible,
				// yes,
				dendrogram,
				confirmOrganization,
				defaultProps,
				multiple,
				yes1,
				treeData,
				// 会员编码框
				serial,
				// 搜索框
				search,
				// 姓名框变化值
				orangutan,
				// 会员姓名
				designation,
				// 时间选择
				whirl,
				value1,
				errorHandler,
				tableData,
				texts,
				append,
				values,
				values1,
				formatSex,
				formatSex1,
				formatSex2,
				formatSex3,
			};
		},
		components: {
			Search,
			WalletFilled,
			Van,
			ShoppingCartFull,
		},
	};
</script>
<style lang="scss" scoped>
	::v-deep .dsa {
		margin-left: 10px !important;
	}

	::v-deep .asd {
		margin-right: 10px !important;
	}

	::v-deep .chart-card::-webkit-scrollbar {
		display: none
	}

	.chart-card {
		height: calc(100vh - 145px);
		overflow: auto;
	}

	.summation {
		display: flex;
		justify-content: space-between;
	}

	.sms-template-action {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 15px;
	}

	::v-deep .el-table__empty-block {
		border-bottom: 1px solid #EBEEF5 !important;
	}

	.hint {
		font-size: 14px;
		color: #909399;
		// font-weight: bold;
		margin-bottom: 15px;
	}

	.el-select--large {
		width: 20%;
		// margin-left: 10px;
	}

	::v-deep .el-table__body {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}

	::v-deep .el-table__header {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}

	.hunt {
		width: 20%;
		margin-right: 10px;
	}

	.grabble {
		width: 100%;
		margin-top: 20px;
		margin-bottom: 15px;
		display: flex;
		justify-content: space-between;
	}

	.el-table__header {
		margin-top: 0;
		margin-bottom: 0;
	}

	.red {
		color: red;
		border: none;
		--el-button-bg-color: none;
		--el-button-hover-bg-color: none;
		--el-button-hover-text-color: none;
	}

	.red:hover {
		color: #fab6b6;
	}

	.bulur {
		color: #409eff;
		border: none;
		--el-button-bg-color: none;
		--el-button-hover-bg-color: none;
		--el-button-hover-text-color: none;
	}

	.bulur:hover {
		color: #a0cfff;
	}

	// .el-button{
	//   border: none;
	//   --el-button-bg-color:none;
	//   --el-button-hover-bg-color:none;
	//   --el-button-hover-text-color:none;
	// }
	.el-scrollbar__thumb {
		background-color: #ffffff;
	}

	.items {
		display: flex;
	}

	.el-select .el-input__inner {
		width: 183px;
	}

	::v-deep .el-dialog--center .el-dialog__body {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	::v-deep .el-select-dropdown__empty {
		display: none !important;
	}

	.el-select-dropdown__item {
		background-color: #ffffff;
		height: 40px !important;
	}

	.el-select-dropdown__item {
		overflow: visible;
	}

	.labor {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 20px;
	}

	::v-deep .el-input--small .el-input__inner {
		height: 30px;
		line-height: 30px;
	}

	.tianjia {
		margin-left: 20px;
	}

	.cancel {
		margin-right: 5px;
		font-weight: 400;
	}

	.cancelgu {
		margin-right: 6px;
		font-weight: bold;
	}

	::v-deep .el-table__inner-wrapper::before {
		width: 0;
	}

	::v-deep .el-table .el-table__cell {
		padding-top: 15px;
		padding-bottom: 15px;
	}

	.el-card.is-always-shadow {
		width: 95%;
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
	}

	::v-deep .el-card__body {
		padding: 0;
	}

	.el-pagination {
		margin-top: 10px;
	}

	.sms-push-table {
		min-height: 400px;
	}

	::v-deep .el-input--small .el-input__inner {
		height: 30px;
		line-height: 30px;
	}

	.tabulation {
		margin-top: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
	}

	::v-deep .organization-dialog {
		height: 80vh;
		display: flex;
		flex-direction: column;
	}

	::v-deep .organization-dialog .el-dialog__body {
		padding: 10px !important;
		height: auto !important;
		flex: 1;
		overflow: auto !important;
	}

	::v-deep .organization-dialog .el-dialog__body::-webkit-scrollbar {
		display: none;
	}

	::v-deep .organization-dialog .el-dialog__footer .el-button {
		width: auto;
		height: 32px;
		font-size: 14px;
	}
</style>
<style>
	/* ::-webkit-scrollbar{display:none} */
	.el-popper {
		z-index: 10000 !important;
	}

	.modality {
		height: 150px !important;
	}

	/* .el-scrollbar__thumb {
  display: none !important;
} */
	.el-select-dropdown__item.selected {
		font-weight: 500 !important;
	}
</style>
